import { render, staticRenderFns } from "./MnemonicPhrase.vue?vue&type=template&id=8a127d88&"
import script from "./MnemonicPhrase.vue?vue&type=script&lang=js&"
export * from "./MnemonicPhrase.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicPhrase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports